import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { setScope } from 'legacy/lut/features/partner360/composedReport'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { ModalDialog } from 'core-components/library/modalDialog'
import { SimplePartnerTable } from 'partner360/components/simplePartnerTable'

import { usePartnersSelect } from './hooks/usePartnersSelect'

interface IProps {
  show: boolean
  onClose: () => void
}

export const GlobalPartnersSelect = ({ show, onClose }: IProps) => {
  const dispatch = useDispatch()

  const onRowSelect = useCallback(
    (item: IWWPartners) => {
      dispatch(setScope([item]))
      onClose()
    },
    [onClose, dispatch]
  )

  const { partnersListProps } = usePartnersSelect({
    onClose,
    isGlobal: true,
    uniqSourceKey: 'global',
    onRowSelect,
  })

  return (
    <ModalDialog
      onClose={onClose}
      show={show}
      size={'lg'}
      content={SimplePartnerTable}
      contentProps={partnersListProps}
    />
  )
}
